// Fundo com um tecido liso da loja (padrão repetido), suavizado por um véu da cor da secção: serve de "papel de parede" em zonas de fundo.
// `veil` = alfa do véu (0 = tecido puro, 1 = só a cor); `size` = tamanho do padrão em px.
// Fundo vichy bege suave, para páginas inteiras (informação legal, resultado da encomenda).
export const pageVichy = () => patternBg("vichy-bege", "250,247,242", 0.86, 240);
// Classes que fazem esse fundo ir de ponta a ponta: sobe por baixo do cabeçalho (60px) e desce por baixo da onda do rodapé (4rem de margem + 30px de onda).
// Quem as usa tem de somar 4rem + 30px ao espaço inferior, para o conteúdo não ficar mais perto do rodapé.
export const PAGE_VICHY_FIT = "-mt-[60px] pt-[60px] -mb-[calc(4rem+30px)]";

export const patternBg =(texture, rgb, veil = 0.8, size = 260) => ({
  background: `linear-gradient(rgba(${rgb},${veil}), rgba(${rgb},${veil})), url(/img/demo/${texture}-flat-800.webp)`,
  backgroundSize: `auto, ${size}px`,
});
